// Mock data for BAIM Landing Page

export const heroData = {
  title: "L'Agilité n'est pas une posture.",
  titleHighlight: "C'est une mécanique de précision.",
  subtitle: "Partenaires experts depuis 2004, nous transformons vos ambitions stratégiques en réalité opérationnelle. De l'infrastructure au capital humain, nous construisons avec vous un modèle de delivery performant, sur-mesure et scalable.",
  cta: "Découvrir notre impact"
};

export const identityData = {
  credo: {
    title: "Notre Credo",
    text: "L'Agilité n'est pas une théorie, c'est de l'ingénierie. Depuis 2004, nous ne faisons qu'une chose : l'Agilité. Pas comme une option, mais comme notre seul métier."
  },
  about: {
    title: "Des vétérans disruptifs",
    subtitle: "avec une expertise enracinée.",
    text: "BAIM est né d'une conviction partagée par des experts présents sur le terrain international depuis 2004. Notre ADN est forgé par plus de deux décennies de pratique réelle. Nous sommes un collectif de partenaires, chacun expert dans sa strate (Tech, Produit, Humain, Stratégie), unis par une passion commune : faire de l'agilité un levier de rentabilité, pas juste un label.",
    tagline: "Un collectif d'experts, une seule obsession : l'efficience."
  },
  values: [
    {
      title: "Expertise Racine",
      text: "Nos partenaires pilotent des transformations complexes depuis 2004."
    },
    {
      title: "Couverture 360°",
      text: "De la salle serveur (Infrastructure/DevOps) jusqu'au Comité Exécutif (Stratégie/OKR)."
    },
    {
      title: "Pragmatisme Radical",
      text: "Nous ne posons pas de méthodologie rigide. Nous co-construisons votre modèle."
    }
  ],
  visual: {
    question: "Le stylo et le visuel au cœur de nos transformations ?",
    text: "Chez BA-in Motion, nous sommes convaincus que pour aller vite, il faut que tout le monde voie la même chose. Notre approche visuelle n'est pas esthétique, elle est chirurgicale.",
    slogan: "Là où les autres écrivent des procédures, nous dessinons des solutions."
  }
};

export const arsenalData = {
  title: "4 leviers pour perturber votre marché.",
  intro: "Notre différence ? Nous ne juxtaposons pas des méthodes. Nous avons intégré 4 dimensions critiques en un système opérationnel unique, forgé par 20 ans de terrain.",
  cards: [
    {
      icon: "TrendingUp",
      title: "Valeur Continue",
      subtitle: "Pas par les délais",
      approach: "Nous arrêtons la mécanique infernale des projets à date fixe qui meurent une fois livrés.",
      result: "Vos équipes ne courent plus après des deadlines, elles gèrent des actifs qui s'apprécient dans le temps."
    },
    {
      icon: "Network",
      title: "Architecture Zéro Friction",
      subtitle: "Organisation scalable",
      approach: "Nous redessinons les interactions entre vos équipes pour éliminer les dépendances bloquantes.",
      result: "Une organisation où la charge cognitive est maîtrisée, des équipes réellement autonomes."
    },
    {
      icon: "Target",
      title: "Pilotage par l'Impact",
      subtitle: "Stratégie connectée",
      approach: "Nous connectons la vision du Comex à la ligne de code du développeur.",
      result: "Chaque effort technique contribue directement et visiblement à la stratégie de l'entreprise."
    },
    {
      icon: "Eye",
      title: "Clarté Visuelle",
      subtitle: "Visual Sensemaking",
      approach: "Nous utilisons la modélisation visuelle et le sketching professionnel comme outil de décision.",
      result: "Une image juste fait gagner des semaines de réunions."
    }
  ]
};

export const offerData = {
  title: "Nos Domaines d'Intervention",
  subtitle: "L'Offre End-to-End",
  blocks: [
    {
      number: "01",
      name: "BUILD",
      subtitle: "Création de Structures Digitales",
      objective: "Pour lancer la machine.",
      description: "Vous devez créer un Digital Center, une Digital Factory ou une Startup interne ? Nous opérons à vos côtés from scratch. Nous mettons en place l'architecture technique, les équipes produits et la culture nécessaire.",
      icon: "Hammer"
    },
    {
      number: "02",
      name: "SCALE",
      subtitle: "Transformation & Design Organisationnel",
      objective: "Pour passer à l'échelle.",
      description: "S'inspirant de Team Topologies et Project to Product, nous restructurons votre organisation pour fluidifier le flux de valeur. Nous brisons les silos entre le métier et l'IT.",
      icon: "Rocket"
    },
    {
      number: "03",
      name: "RESCUE",
      subtitle: "Optimisation & Success Stories",
      objective: "Pour débloquer la valeur.",
      description: "Votre transformation stagne ? Nous intervenons là où les autres échouent. Nous analysons vos chaînes de valeur (VSM) et corrigeons les dysfonctionnements opérationnels.",
      icon: "Wrench"
    }
  ]
};

export const footerData = {
  title: "Parlons de votre contexte.",
  text: "Échangez directement avec un expert, pas un commercial. Discutons de vos enjeux de transformation ou de création.",
  cta: "Prendre rendez-vous",
  copyright: "© 2025 BAIM - Business Agility in Motion. Tous droits réservés."
};

export const navigationItems = [
  { id: "hero", label: "Accueil", icon: "Home" },
  { id: "identity", label: "Identité", icon: "Users" },
  { id: "arsenal", label: "Arsenal", icon: "Shield" },
  { id: "offer", label: "Offre", icon: "Briefcase" },
  { id: "contact", label: "Contact", icon: "Mail" }
];
